import { render, staticRenderFns } from "./leaveTempForm.vue?vue&type=template&id=5af1a548&"
import script from "./leaveTempForm.vue?vue&type=script&lang=js&"
export * from "./leaveTempForm.vue?vue&type=script&lang=js&"
import style0 from "./leaveTempForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports